import { IsNumber, IsBoolean, IsOptional } from "class-validator";

export class TransactionRefundDto {
  // custom refund amount
  @IsOptional()
  @IsNumber()
  amount?: number;

  // The entry-fee (club) portion of `amount`, same units as `amount`. Set by the
  // custom-amount refund flow: the secretary enters the entry-fee dollars to give
  // back, the client adds the proportional Eager Dog fee on top to form `amount`,
  // and the server uses this as the numerator for the intended application-fee
  // refund (same top-down formula as refund-request approval). When omitted,
  // `amount` is treated as the gross refund and the entry portion defaults to it.
  @IsOptional()
  @IsNumber()
  entry_amount?: number;

  @IsOptional()
  @IsBoolean()
  refund_application_fee?: boolean;
}
